import { render, staticRenderFns } from "./ProjectInscriptionComponent.vue?vue&type=template&id=2499fa5e"
import script from "./ProjectInscriptionComponent.vue?vue&type=script&lang=js"
export * from "./ProjectInscriptionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports